import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import VolleyGame from "../components/game/VolleyGame";

export default function PlayPage() {
  return (
    <div className="sections">
      <div className="page-hero">
        <h1 className="page-title">Keep it up.</h1>
        <p className="page-blurb">
          You found the hidden court. Click or tap the ball to keep it in the
          air. Every touch extends the rally, and the floor ends it.
        </p>
        <Link className="back-link" to="/"><ArrowLeft size={14} weight="bold" /> Back home</Link>
      </div>
      <VolleyGame />
    </div>
  );
}
